export interface IBoostersResponse {
    boosters: IWeeklyBoosterWithViewStatusDto[]; // Array of 5 boosters (or fewer if last set)
    currentCycleNumber: number; // Current cycle/set number (0-based)
    viewedCountInCycle: number; // Number of boosters viewed in current cycle
    totalBoostersInCycle: number; // Total boosters in current cycle (usually 5)
}

export interface IAllowedDepartment {
    id: string; // UUID
    name: string;
    description?: string;
    displayOrder?: number;
    isActive: boolean;
}

export interface IWeeklyBoosterWithViewStatusDto {
    id: string; // UUID
    title: string;
    content: IWeeklyBoosterContent; // JSON structure
    imageUrl?: string;
    priority?: number;
    isActive: boolean;
    allowedDepartments?: IAllowedDepartment[];
    createdAt: Date;
    category?: IWeeklyBoosterCategoryDto;
    isViewed: boolean; // true when all the steps are viewed
    cycleNumber: number;
}

export interface IWeeklyBoosterContent {
    headerLine: string;
    objective: string;
    steps: IWeeklyBoosterStep[];
}

export interface IWeeklyBoosterStep {
    order: number; // must be unique
    adviceMessage: string;
    feedbackMessage: string;
    isViewed: boolean; // true when the step is viewed
}

export interface IWeeklyBoosterCategoryDto {
    id: string; // UUID
    name: string;
    description?: string;
    displayOrder?: number;
    isActive: boolean;
}

export enum AllowedDepartment {
    FRONT_OF_HOUSE = 'FRONT_OF_HOUSE',
    FOOD_BEVERAGE = 'FOOD_BEVERAGE',
    HOUSEKEEPING = 'HOUSEKEEPING',
    PRODUCT = 'PRODUCT',
}
